module.exports = __webpack_public_path__ + "img/modelos-tecnicos.eacae1b4.svg";